import { FormControl, FormGroup } from '@angular/forms';
import { DeviceBase } from './device-base';
import { PropertyMetadata } from '../../properties/property-types';
import { RegisterElement } from '../element-decorator';
import { Lane } from '../access-control/lane';
import { NetworkDeviceBase } from './network-device-base';

@RegisterElement()
export class Camera extends NetworkDeviceBase {
    protected sizeInMeters: number = 1;
    public override TypeName: string = "Camera";
    public override ParentType: string | null = "Lane";
    public override ParentFormGroupName: string | null = "Cameras";

    constructor(formGroup: FormGroup) {
        super(formGroup, 'assets/icons/camera.svg');
        
        if (!formGroup.contains('Resolution')) {
            formGroup.addControl('Resolution', new FormControl('1080p'));
        }
    }

    public override clone(): Camera {
        return new Camera(this.formGroup);
    }

    public override getPropertyMetadata(): PropertyMetadata[] {
        return [
            ...super.getPropertyMetadata(),
            {
                formControlName: 'Resolution',
                displayName: 'Resolution',
                inputType: { 
                    type: 'select',
                    options: [
                        { value: '720p', label: '720p' },
                        { value: '1080p', label: '1080p' },
                        { value: '4k', label: '4K' }
                    ]
                },
                order: 3,
                category: 'Properties'
            }
        ];
    }

    public override default(): Camera {
        return this;
    }
} 
